var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPatients(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 66,
    viewBox: "0 0 59 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.984 14.7272C15.8727 14.7272 19.0251 11.6542 19.0251 7.86359C19.0251 4.07293 15.8727 1 11.984 1C8.09528 1 4.94287 4.07293 4.94287 7.86359C4.94287 11.6542 8.09528 14.7272 11.984 14.7272Z",
    stroke: "#008187",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6986 9.93523H22.6445",
    stroke: "#008187",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.84772 9.93523H5.07476",
    stroke: "#008187",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93951 7.86663H13.5313L17.6813 3.8213",
    stroke: "#008187",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.90198 25.9543V65H19.025V25.9543",
    stroke: "#008187",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3884 42.6742V26.0278C23.3884 24.0037 22.5635 22.0626 21.0953 20.6314C19.6271 19.2002 17.6357 18.3961 15.5593 18.3961H8.83216C6.75676 18.4002 4.7675 19.2054 3.29967 20.6357C1.83185 22.0659 1.00498 24.0047 1 26.0278V42.6742",
    stroke: "#008187",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.93439 18.3961C8.02788 19.3837 8.49642 20.3016 9.24816 20.9699C9.9999 21.6381 10.9806 22.0086 11.998 22.0086C13.0154 22.0086 13.9961 21.6381 14.7479 20.9699C15.4996 20.3016 15.9681 19.3837 16.0616 18.3961",
    stroke: "#008187",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9838 39.2195V22.1997",
    stroke: "#008187",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9838 65V44.2256",
    stroke: "#008187",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8884 1.03675C43.534 1.17345 42.2492 1.69006 41.1898 2.524C40.1305 3.35794 39.3419 4.47343 38.9196 5.73535C38.4973 6.99727 38.4595 8.35147 38.8106 9.63393C39.1618 10.9164 39.8869 12.0721 40.8982 12.961C41.9094 13.8499 43.1634 14.4339 44.5082 14.6423C45.853 14.8507 47.2309 14.6745 48.4751 14.1351C49.7192 13.5956 50.7763 12.7161 51.5181 11.603C52.2599 10.4899 52.6547 9.19098 52.6546 7.86362C52.6546 7.86362 52.6546 7.8422 52.6546 7.82996C52.4148 7.85353 52.1737 7.86477 51.9326 7.86362C50.0712 7.86446 48.2851 7.14673 46.9651 5.8674C45.645 4.58807 44.8984 2.85125 44.8884 1.03675V1.03675Z",
    stroke: "#008187",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8884 1V1.03672C45.1282 1.0122 45.3692 0.999944 45.6104 1C47.4718 0.999978 49.2575 1.71848 50.577 2.99838C51.8965 4.27829 52.6423 6.01543 52.6515 7.82993",
    stroke: "#008187",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5316 25.9543V65H52.6546V25.9543",
    stroke: "#008187",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M57.018 42.6742V26.0278C57.013 24.0021 56.184 22.061 54.7128 20.6303C53.2415 19.1996 51.2483 18.3961 49.1701 18.3961H42.4649C40.3868 18.3961 38.3935 19.1996 36.9223 20.6303C35.4511 22.061 34.6221 24.0021 34.6171 26.0278V42.6742",
    stroke: "#008187",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6102 65V44.2256",
    stroke: "#008187",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3193 19.2438L45.8236 26.7041L52.3279 19.2438",
    stroke: "#008187",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatients);
export default __webpack_public_path__ + "static/media/patients.1e0ca8a06fe7faa878b72d2d69688b5a.svg";
export { ForwardRef as ReactComponent };